<div class="wrapper">

  <div class="row">

    <div class="col-sm-12">

      <div class="card bb-panel">
        <form [formGroup]="memberDetailsForm" autocomplete="chrome-off" class="col-sm-12" role="form"
          aria-label="My account details form" [class.submitted]="submitted">
          <h4 class="mt-1 pb-4">Personal information</h4>

          <div class="form-group">
            <label for="account_first_name"><span aria-hidden="true" class="form-field-required-marker">
                *</span> {{'ACCOUNT.MY_ACCOUNT.FIRST_NAME_LBL' | translate}}</label>
            <input id="account_first_name" type="text" class="form-control" formControlName="first_name" role="textbox">
            <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
              <div *ngIf="form.first_name.errors.required" role="alert">
                {{'ACCOUNT.MY_ACCOUNT.FIRST_NAME_REQUIRED' | translate}}</div>
            </div>
          </div>

          <div class="form-group">
            <label for="account_last_name"><span aria-hidden="true" class="form-field-required-marker">
                *</span> {{'ACCOUNT.MY_ACCOUNT.LAST_NAME_LBL' | translate}}</label>
            <input id="account_last_name" type="text" class="form-control" formControlName="last_name" role="textbox">
            <div *ngIf="submitted && form.last_name.errors" class="invalid-feedback">
              <div *ngIf="form.last_name.errors.required" role="alert">
                {{'ACCOUNT.MY_ACCOUNT.LAST_NAME_REQUIRED' | translate}}</div>

            </div>
          </div>

          <div class="form-group">
            <label for="account_mobile"> {{'ACCOUNT.MY_ACCOUNT.CONTACT_NUMBER_LBL' | translate}}</label>
            <input id="account_mobile" type="search" class="form-control" formControlName="mobile" role="textbox"
              (keypress)="keyPressNumberField($event)" maxlength="11">
            <div *ngIf="submitted && form.mobile.errors" class="invalid-feedback">
              <div *ngIf="form.mobile.errors.required" role="alert">Contact number is
                required</div>
            </div>
            <div *ngIf="submitted && form.mobile.errors" class="invalid-feedback">
              <div *ngIf="form.mobile.errors.minlength" role="alert">
                Please enter a valid contact number</div>
            </div>
          </div>
          <!-- 
          <div class="form-group">
            <label>{{'ACCOUNT.MY_ACCOUNT.ADDRESS_LBL' | translate}}</label>
            <input type="text" class="form-control" formControlName="address1" role="textbox"
              aria-label="address 1 input field">
          </div>

          <div class="form-group">
            <label>{{'ACCOUNT.MY_ACCOUNT.ADDRESS_2_LBL' | translate}}</label>
            <input type="text" class="form-control" formControlName="address2" role="textbox"
              aria-label="address 2 input field">
          </div>

          <div class="form-group">
            <label>{{'ACCOUNT.MY_ACCOUNT.TOWN_LBL' | translate}}</label>
            <input type="text" class="form-control" formControlName="address4" role="textbox"
              aria-label="Address 4 input field">
          </div>

          <div class="form-group">
            <label>{{'ACCOUNT.MY_ACCOUNT.COUNRTY_LBL' | translate}}</label>
            <input type="text" class="form-control" formControlName="country" role="textbox"
              aria-label="Country input field">
          </div>

          <div class="form-group">
            <label>{{'ACCOUNT.MY_ACCOUNT.POSTCODE_LBL' | translate}}</label>
            <input type="text" class="form-control" formControlName="postcode" role="textbox"
              aria-label="postcode input field">
          </div> -->

          <div class="form-group">
            <label for="account_email"><span aria-hidden="true" class="form-field-required-marker">
                *</span> {{'ACCOUNT.MY_ACCOUNT.EMAIL_LBL' | translate}}</label>
            <input id="account_email" type="text" class="form-control" formControlName="email" role="textbox">
          </div>


          <!-- <h5>{{'FORM.REGISTER.ADDITIONAL_HEADER' | translate}}</h5>
          <hr /> -->
          <!-- Customer questions -->
          <!-- <div *ngFor="let question of customerQuestions;">
            <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_field'">
              <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                  *</span> {{question.name}}</label>
              <input type="text" class="form-control" formControlName="{{question.reference}}" role="textbox"
                attr.aria-label="{{question.name}} input field">
              <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                </div>
              </div>
            </div>


            <div class="form-group" *ngIf="question.visible && question.detail_type == 'text_area'">
              <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                  *</span> {{question.name}}</label>
              <textarea class="form-control" formControlName="{{question.reference}}"
                attr.aria-label="{{question.name}} text area field"></textarea>
              <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="question.visible && question.detail_type == 'number'">
              <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                  *</span> {{question.name}}</label>
              <input type="number" class="form-control" formControlName="{{question.reference}}"
                attr.aria-label="{{question.name}} input field">
              <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                </div>
              </div>
            </div>

            <div
              *ngIf="question.visible && question.detail_type == 'select' && question.id == bookingQuestionsConfig.schoolNameSelectionAccounts">
              <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                  *</span> {{question.name}}</label>
              <input list="question.reference" formControlName="{{question.reference}}"
                class="form-control selectpicker" (change)="onQuestionChange()">
              <datalist id="question.reference">
                <option *ngFor="let option of question.options" [value]="option.name">
                  {{option.name}}
                </option>
              </datalist>
              <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                </div>
                <div *ngIf="form[question.reference].errors.selectedSchoolErr" role="alert">
                  {{form[question.reference].errors.selectedSchoolErr}}
                </div>
              </div>
            </div>

            <div class="form-group"
              *ngIf="question.visible && question.detail_type == 'select' && question.id != bookingQuestionsConfig.schoolNameSelectionAccounts">
              <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                  *</span> {{question.name}}</label>
              <select formControlName="{{question.reference}}" class="form-control" (change)="onQuestionChange()"
                attr.aria-label="{{question.name}}">
                <option></option>
                <option *ngFor="let option of question.options" [value]="option.name">
                  {{option.name}}
                </option>
              </select>
              <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="question.visible && question.detail_type == 'date'">
              <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                  *</span> {{question.name}}</label>
              <input matInput formControlName="{{question.reference}}" [matDatepicker]="picker" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker>
              </mat-datepicker>
              <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                <div *ngIf="form[question.reference].errors.required" role="alert">{{question.name}}
                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                </div>
              </div>
            </div>
          </div> -->

          <div class="row mt-4">
            <div class="col-6">
              <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                aria-label="Cancel changes to your personal information" (click)="cancel()"
                [disabled]="memberDetailsForm.pristine">{{'COMMON.CANCEL' | translate}}</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                type="button" aria-label="Update your personal information" (click)="onSubmit()">{{'COMMON.UPDATE' |
                translate}}</button>
            </div>
          </div>
          <hr>

          <span *ngIf="showForms">
            <h4>Address(es) where the waste is coming from</h4>
            <div *ngFor="let address of addresses; index as idx">
              <div class="form-group" *ngIf="addressesShow[idx].edit === false">
                <label>{{'ACCOUNT.MY_ACCOUNT.ADDRESS_LBL' | translate}} {{idx+1}} of
                  {{maxChildren}}</label>
                <div id="stored_address_{{idx}}" class="form-control formControlDisabled centerMeText">
                  {{address.address}}
                </div>
              </div>

              <app-form-builder formId="address_registration_form" [formData]="[address]" [showSubmit]=false [idx]="idx"
                [submitted]="submitted" [maxChildren]="1" (formStatus)="test($event)"
                [overrideCounter]="idx+1 + ' of ' + maxChildren" [allData]="addresses"
                *ngIf="addressesShow[idx].edit === true"></app-form-builder>

              <span *ngIf="addressesShow[idx].destroy === true">
                <h4>Are you sure you want to remove this address?</h4>
              </span>
              <div class="row mt-4">
                <div class="col-6">
                  <span *ngIf="addressesShow[idx].destroy === false">
                    <!-- <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                      *ngIf="addressesShow[idx].edit === false" (click)="addressesShow[idx].edit = true">Edit</button> -->
                    <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                      attr.aria-label="Cancel editing address {{idx+1}}" *ngIf="addressesShow[idx].edit === true"
                      (click)="cancelEdit(addressesShow,addresses,idx,address.address_no)">Cancel</button>
                  </span>
                  <span *ngIf="addressesShow[idx].destroy === true">
                    <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                      attr.aria-label="Confirm removal of address {{idx+1}}"
                      (click)="destroy('address_registration_form',idx)">Confirm</button>
                  </span>
                </div>

                <div class="col-6">
                  <span *ngIf="addressesShow[idx].destroy === false">
                    <button type="button"
                      class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                      attr.aria-label="Remove address {{idx+1}}" (click)="addressesShow[idx].destroy = true"
                      *ngIf="addressesShow[idx].edit === false && addresses.length > 1">Remove</button>
                    <button type="button"
                      class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                      attr.aria-label="Save address {{idx+1}}" (click)="save('address_registration_form',idx)"
                      *ngIf="addressesShow[idx].edit === true">Save</button>
                  </span>
                  <span *ngIf="addressesShow[idx].destroy === true">
                    <button type="button"
                      class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                      attr.aria-label="Keep address {{idx+1}}"
                      (click)="addressesShow[idx].destroy = false">Cancel</button>
                  </span>
                </div>
              </div>
              <br>
              <hr *ngIf="idx < addresses.length -1">
            </div>
            <div *ngIf="addresses.length < maxChildren">
              <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                (click)="add('address_registration_form')">Add another address</button>
            </div>
            <hr>
            <h4>Vehicle(s)</h4>
            <div *ngFor="let vehicle of vehicles; index as idx">
              <div class="form-group" *ngIf="vehiclesShow[idx].edit === false">
                <label>{{'ACCOUNT.MY_ACCOUNT.VEHICLE_LBL' | translate}} {{idx+1}} of
                  {{maxChildren}}</label>
                <div id="stored_vehicle_{{idx}}" class="form-control formControlDisabled centerMeText">
                  {{vehicle.mode_of_transport}}
                </div>
                <br>
                <div *ngIf="vehicle.vehicle_registration && vehicle.vehicle_registration !== 'undefined'"
                  class="form-control formControlDisabled centerMeText"> {{vehicle.vehicle_registration}}
                </div>
                <br>
                <div *ngIf="vehicle.vehicle_make && vehicle.vehicle_make !== 'undefined'"
                  class="form-control formControlDisabled centerMeText"> {{vehicle.vehicle_make}}
                </div>
                <br>
                <div *ngIf="vehicle.vehicle_colour && vehicle.vehicle_colour !== 'undefined'"
                  class="form-control formControlDisabled centerMeText"> {{vehicle.vehicle_colour}}
                </div>
              </div>

              <app-form-builder formId="vehicle_registration_form" [formData]="[vehicle]" [showSubmit]=false [idx]="idx"
                [submitted]="submitted" [maxChildren]="1" (formStatus)="test($event)"
                [overrideCounter]="idx+1 + ' of ' + maxChildren" [allData]="vehicles"
                *ngIf="vehiclesShow[idx].edit === true"></app-form-builder>

              <span *ngIf="vehiclesShow[idx].destroy === true">
                <h4>Are you sure you want to remove this vehicle?</h4>
              </span>
              <div class="row mt-4">
                <div class="col-6">
                  <span *ngIf="vehiclesShow[idx].destroy === false">
                    <!-- <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                      *ngIf="vehiclesShow[idx].edit === false" (click)="vehiclesShow[idx].edit = true">Edit</button> -->
                    <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                      attr.aria-label="Cancel editing vehicle {{idx+1}}" *ngIf="vehiclesShow[idx].edit === true"
                      (click)="cancelEdit(vehiclesShow,vehicles,idx,vehicle.vehicle_no)">Cancel</button>
                  </span>
                  <span *ngIf="vehiclesShow[idx].destroy === true">
                    <button type="button" class="btn btn-primary govuk-button button-sizer col-12 col-sm-10 col-md-6"
                      attr.aria-label="Confirm removal of vehicle {{idx+1}}"
                      (click)="destroy('vehicle_registration_form',idx)">Confirm</button>
                  </span>
                </div>

                <div class="col-6">
                  <span *ngIf="vehiclesShow[idx].destroy === false">
                    <button type="button"
                      class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                      attr.aria-label="Remove vehicle {{idx+1}}" (click)="vehiclesShow[idx].destroy = true"
                      *ngIf="vehiclesShow[idx].edit === false && vehicles.length > 1">Remove</button>
                    <button type="button"
                      class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                      attr.aria-label="Save vehicle {{idx+1}}" (click)="save('vehicle_registration_form',idx)"
                      [disabled]="formStatus['vehicle_registration_form' + idx]"
                      *ngIf="vehiclesShow[idx].edit === true">Save</button>
                  </span>
                  <span *ngIf="vehiclesShow[idx].destroy === true">
                    <button type="button"
                      class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-6"
                      attr.aria-label="Keep vehicle {{idx+1}}"
                      (click)="vehiclesShow[idx].destroy = false">Cancel</button>
                  </span>
                </div>
              </div>
              <br>
              <hr *ngIf="idx < vehicles.length -1">
            </div>
            <div *ngIf="vehicles.length < maxChildren">
              <button type="button" class="btn btn-primary govuk-button button-sizer col-sm-10 col-md-6"
                (click)="add('vehicle_registration_form')">Add another vehicle</button>
            </div>
          </span>
        </form>
      </div>


    </div>
  </div>
</div>